/**
 * Created by seaasun on 2018/2/9.
 */
import _ from 'lodash'

const rulesDict = {
  require: {
    fu (val) {
      return !_.isEmpty(val) || _.isNumber(val)
    },
    desc: 'Required'
  },
  email: {
    fu (val) {
      return _.isString(val) && val.indexOf('@') > 0 && val.indexOf('@') < val.length - 1
    },
    desc: 'Need Email'
  },
  zip: {
    fu (val) {
      return !isNaN(val) && val.length === 5
    },
    desc: 'Need ZIP Code, 5 digits'
  },
  number: {
    fu (val) {
      return !isNaN(val)
    },
    desc: 'Need Number'
  },
  min: {
    fu (val, payload) {
      return val >= payload
    },
    desc: 'mus'
  },
  minLength: {
    fu (val, payload) {
      return val.length >= payload
    },
    desc: 'mus'
  },
  max: {
    fu (val, payload) {
      return val <= payload
    },
    desc: 'max'
  },
  creditCard: {
    fu (val, payload) {
      let n = Number(val.substr(0,1))
      return !isNaN(val) && val.length <= 17 && val.length >= 14 && n>=3 && n<=6
    },
    desc: 'The card number is not valid.'
  }
}

function parseErryType (rule) {
  if (_.isString(rule)) {
    return {
      val: true,
      desc: rulesDict[rule].desc,
      fu: rulesDict[rule].fu
    }
  } else {
    return Object.assign({}, rulesDict[rule.type], rule)
  }
}

function onlyErroy (val, rules) {
  for (let i = 0; i < rules.length; i++) {
    let rule = parseErryType(rules[i])
    if (!rule.fu(val, rule.payload)) {
      return {
        isError: true,
        desc: rule.desc
      }
    }
  }
  return {
    isError: false,
    desc: ''
  }
}

function manyErrory () {

}
export default function (val, rules, only) {
  only = only === undefined ? true : only  // display only one error
  if (_.isString(rules)) rules = [rules]

  if (only) {
    return onlyErroy(val, rules)
  } else {
    return manyErrory(val, rules)
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/validate.js